import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_aside = _resolveComponent("el-aside")!

  return (_openBlock(), _createBlock(_component_el_aside, {
    width: "220px",
    class: "sidebar"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_menu, {
        class: "el-menu-vertical-demo",
        "background-color": "#333",
        "text-color": "#fff",
        "active-text-color": "#ffd04b",
        "default-active": _ctx.activeMenuItem
      }, {
        default: _withCtx(() => [
          (_ctx.hasAccess([..._ctx.managerRoles, ..._ctx.adminRoles, ..._ctx.accountantRoles]))
            ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 0,
                index: "/directory",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleMenuClick('/directory')))
              }, {
                default: _withCtx(() => _cache[23] || (_cache[23] = [
                  _createElementVNode("span", null, "Справочник ДО", -1)
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.hasAccess([..._ctx.adminRoles, ..._ctx.managerRoles]))
            ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 1,
                index: "/timesheet/list",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleMenuClick('/timesheet')))
              }, {
                default: _withCtx(() => _cache[24] || (_cache[24] = [
                  _createElementVNode("span", null, "Загруженные табели", -1)
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.hasAccess([]))
            ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 2,
                index: "/report",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleMenuClick('/report')))
              }, {
                default: _withCtx(() => _cache[25] || (_cache[25] = [
                  _createElementVNode("span", null, "Отчеты", -1)
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.hasAccess([..._ctx.managerRoles, ..._ctx.adminRoles]))
            ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 3,
                index: "/kindergarten/heads",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleMenuClick('/kindergarten/heads')))
              }, {
                default: _withCtx(() => _cache[26] || (_cache[26] = [
                  _createElementVNode("span", null, "Директора ДО", -1)
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.hasAccess([..._ctx.managerRoles, ..._ctx.adminRoles]))
            ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 4,
                index: "/kindergarten/retention",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleMenuClick('/kindergarten/retention')))
              }, {
                default: _withCtx(() => _cache[27] || (_cache[27] = [
                  _createTextVNode("Авансирование/удержание")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.hasAccess([..._ctx.managerRoles, ..._ctx.adminRoles]))
            ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 5,
                index: "/report/to/sign",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleMenuClick('/report/to/sign')))
              }, {
                default: _withCtx(() => _cache[28] || (_cache[28] = [
                  _createTextVNode("Отчеты на подписание")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.hasAccess([..._ctx.managerRoles, ..._ctx.adminRoles]))
            ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 6,
                index: "/acts/reconciliation",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleMenuClick('/acts/reconciliation')))
              }, {
                default: _withCtx(() => _cache[29] || (_cache[29] = [
                  _createElementVNode("span", null, "Сверка актов", -1)
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.hasAccess([..._ctx.managerRoles, ..._ctx.adminRoles, ..._ctx.accountantRoles]))
            ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 7,
                index: "/acts/acceptance",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleMenuClick('/acts/acceptance')))
              }, {
                default: _withCtx(() => _cache[30] || (_cache[30] = [
                  _createElementVNode("span", null, "Принятие актов", -1)
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.hasAccess([..._ctx.managerRoles, ..._ctx.adminRoles, ..._ctx.accountantRoles, ..._ctx.kindergarteHeadRoles]))
            ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 8,
                index: "/invoice/reconciliation",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleMenuClick('/invoice/reconciliation')))
              }, {
                default: _withCtx(() => _cache[31] || (_cache[31] = [
                  _createElementVNode("span", null, "Работа с ЭСФ", -1)
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.hasAccess([..._ctx.accountantRoles, ..._ctx.adminRoles]))
            ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 9,
                index: "/kindergarten/fact/payment",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleMenuClick('/kindergarten/fact/payment')))
              }, {
                default: _withCtx(() => _cache[32] || (_cache[32] = [
                  _createElementVNode("span", null, "Фактическая оплата", -1)
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.hasAccess(_ctx.kindergartenHeadRoles))
            ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 10,
                index: "/report-sign",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleMenuClick('/report-sign')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Отчеты на подписание " + _toDisplayString(_ctx.documentCountForSign), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.hasAccess([..._ctx.managerRoles, ..._ctx.adminRoles, ..._ctx.accountantRoles]))
            ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 11,
                index: "/report/1c",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleMenuClick('/report/1c')))
              }, {
                default: _withCtx(() => _cache[33] || (_cache[33] = [
                  _createTextVNode("Отчет на 1C")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.hasAccess([..._ctx.managerRoles, ..._ctx.adminRoles, ..._ctx.accountantRoles]))
            ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 12,
                index: "/report/forMIO",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleMenuClick('/report/forMIO')))
              }, {
                default: _withCtx(() => _cache[34] || (_cache[34] = [
                  _createTextVNode("Отчет для МИО")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.hasAccess([..._ctx.kindergartenHeadRoles]))
            ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 13,
                index: "/kindergarten/act/reconciliation",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.handleMenuClick('/kindergarten/act/reconciliation')))
              }, {
                default: _withCtx(() => _cache[35] || (_cache[35] = [
                  _createTextVNode("Сверка Акт")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.hasAccess([..._ctx.adminRoles, ..._ctx.accountantRoles]))
            ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 14,
                index: "/kindergarten/act/reconciliation/status",
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.handleMenuClick('/kindergarten/act/reconciliation/status')))
              }, {
                default: _withCtx(() => _cache[36] || (_cache[36] = [
                  _createTextVNode("Загруженные акты")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.hasAccess([..._ctx.adminRoles, ..._ctx.managerSpkRoles, ..._ctx.managerRoles]))
            ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 15,
                index: "/admin/notifications",
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.handleMenuClick('/admin/notifications')))
              }, {
                default: _withCtx(() => _cache[37] || (_cache[37] = [
                  _createTextVNode("Уведомление")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.hasAccess([..._ctx.adminRoles]))
            ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 16,
                index: "/admin/audit",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.handleMenuClick('/admin/audit')))
              }, {
                default: _withCtx(() => _cache[38] || (_cache[38] = [
                  _createTextVNode("Журнал аудита")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.hasAccess([..._ctx.adminRoles]))
            ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 17,
                index: "/admin/lms-log",
                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.handleMenuClick('/admin/lms-log')))
              }, {
                default: _withCtx(() => _cache[39] || (_cache[39] = [
                  _createTextVNode("Обращения LMS")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.hasAccess([..._ctx.kindergartenHeadRoles]))
            ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 18,
                index: "/client/notifications",
                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.handleMenuClick('/client/notifications')))
              }, {
                default: _withCtx(() => _cache[40] || (_cache[40] = [
                  _createTextVNode("Уведомление")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.hasAccess([..._ctx.adminRoles, ... _ctx.managerRoles]))
            ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 19,
                index: "/children",
                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.handleMenuClick('/children')))
              }, {
                default: _withCtx(() => _cache[41] || (_cache[41] = [
                  _createTextVNode("Дети ДО")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.hasAccess([..._ctx.adminRoles, ..._ctx.managerRoles]))
            ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 20,
                index: "/children/duplicates",
                onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.handleMenuClick('/children/duplicates')))
              }, {
                default: _withCtx(() => _cache[42] || (_cache[42] = [
                  _createTextVNode("Дубли контингента")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.hasAccess([..._ctx.adminRoles, ... _ctx.managerRoles]))
            ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 21,
                index: "/kindergarten-analytics",
                onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.handleMenuClick('/kindergarten/analytics')))
              }, {
                default: _withCtx(() => _cache[43] || (_cache[43] = [
                  _createTextVNode("Статусы по ДО ")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.hasAccess([..._ctx.kindergartenHeadRoles, ..._ctx.findirRoles, ..._ctx.accountantRoles]))
            ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 22,
                index: "/kindergarten-1c-act-reconciliation",
                onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.handleMenuClick('/kindergarten-1c-act-reconciliation')))
              }, {
                default: _withCtx(() => _cache[44] || (_cache[44] = [
                  _createTextVNode("Акты сверок 1С ")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["default-active"])
    ]),
    _: 1
  }))
}